import { App } from '@launcher/App';
import { AppProviders } from '@launcher/AppProviders';
import { logger } from '@services/logger/logger.service';
import { monitoring } from '@services/monitoring';
import { Buffer } from 'buffer';
import { createRoot } from 'react-dom/client';
import './tailwind.css';
import './index.less';

(window.document.getElementById('SECTION_1') as HTMLElement).style.display = 'none';

// biome-ignore lint/style/noNamespace: TODO refactore me
declare namespace globalThis {
  let Buffer: any;
}

// Required for PDF viewer
globalThis.Buffer = Buffer;

// Object.hasOwn is not available in Chromium < 93 (Electron < 14)
if (!Object.hasOwn) {
  // biome-ignore lint/suspicious/noPrototypeBuiltins: Prototype polution for older Electron that we can't update
  Object.hasOwn = (obj: object, key: PropertyKey) => Object.prototype.hasOwnProperty.call(obj, key);
}

monitoring.init();
logger.startFlushing();

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <AppProviders>
    <App />
  </AppProviders>,
);
